import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CreativeProcess = () => {
  const cultureValues = [
    {
      id: 1,
      icon: 'BoltIcon',
      title: 'Fearless Creativity',
      description: 'We push boundaries and challenge conventions. Safe is boring. Bold is our baseline.'
    },
    {
      id: 2,
      icon: 'UsersIcon',
      title: 'Collaborative Excellence',
      description: 'Great work happens when diverse minds unite. We celebrate different perspectives and collective genius.'
    },
    {
      id: 3,
      icon: 'ChartBarIcon',
      title: 'Continuous Growth',
      description: 'The creative industry evolves daily. We invest in learning, experimentation, and staying ahead.'
    },
    {
      id: 4,
      icon: 'HeartIcon',
      title: 'Authentic Connection',
      description: 'We build real relationships—with clients, partners, and each other. No corporate BS, just genuine human connection.'
    },
    {
      id: 5,
      icon: 'TrophyIcon',
      title: 'Results Accountability',
      description: 'Beautiful work that doesn’t perform is just decoration. We measure success by client outcomes, not awards.'
    },
    {
      id: 6,
      icon: 'GlobeIcon',
      title: 'African Pride',
      description: 'We\'re proudly African, globally competitive. Our cultural perspective is our superpower, not a limitation.'
    }
  ];

  const qualityStandards = [
    { title: "Technical Excellence", icon: "AwardIcon", description: "Broadcast-quality standards for every deliverable" },
    { title: "Creative Innovation", icon: "SparklesIcon", description: "Fresh perspectives that differentiate your brand" },
    { title: "Timeline Reliability", icon: "ClockIcon", description: "Systematic approach ensuring on-time delivery" },
    { title: "Client Collaboration", icon: "UsersIcon", description: "Transparent communication throughout the process" }
  ];

  return (
    <div className="space-y-8 lg:space-y-12">
      {/* Section Header */}
     
      <div className="text-center max-w-3xl mx-auto mb-4 space-y-2">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-headline font-black text-foreground">
          Our <span className="text-red-600">Culture</span>
        </h2>
        <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
          These values aren't wall decorations—they're the DNA of how we work, create, and win together.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
        {/* Values List */}
        <div className="space-y-6">
          {cultureValues.map((value) => (
            <div
              key={value.id}
              className="group flex items-start space-x-4 p-4 bg-card rounded-xl border shadow-subtle hover:border-red-600 transition-all duration-300 hover:shadow-lg"
            >
              <div className="hidden sm:block p-4 border shadow-subtle hover:border-red-600 rounded-xl  group-hover:scale-125 transition-all duration-300">
                <Icon
                  name={value.icon}
                  size={28}
                  variant="solid"
                  className="text-red-600 group-hover:text-red-500 transition-colors duration-300"
                />
              </div>
              <div className="flex-1 space-y-2">
                <h3 className="text-xl font-headline font-bold text-foreground group-hover:text-red-600 transition-colors duration-300">
                  {value.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Culture Images */}
        <div className="space-y-6 hidden lg:block">
          {/* <div className="relative h-64 rounded-2xl overflow-hidden">
            <Image
              src="/assets/images/hero/about1.png"
              alt=""
              className="w-full h-auto"
            />
          </div> */}
          <div className="grid grid-cols-2 gap-6">
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about1.png"
                alt=""
                className="w-full h-auto"
              />
            </div>
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about2.png"
                alt="Creative professionals working collaboratively on design project with digital tablets"
                className="w-full h-auto object-contain object-center"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about3.png"
                alt="Team members celebrating success with high fives in modern office space"
                className="w-full h-auto"
              />
            </div>
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about4.png"
                alt="Creative professionals working collaboratively on design project with digital tablets"
                className="w-full h-auto"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about5.png"
                alt=""
                className="w-full h-auto object-center"
              />
            </div>
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about6.png"
                alt="Creative professionals working collaboratively on design project with digital tablets"
                className="w-full h-auto object-center"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about7.png"
                alt="Team members celebrating success with high fives in modern office space"
                className="w-full h-auto object-center"
              />
            </div>
            <div className="relative h-48 rounded-2xl overflow-hidden">
              <Image
                src="/assets/images/hero/about8.png"
                alt="Creative professionals working collaboratively on design project with digital tablets"
                className="w-full h-auto object-center"
              />
            </div>
          </div>
          {/* <div className="relative h-64 rounded-2xl overflow-hidden">
            <Image
              src="/assets/images/hero/about5.png"
              alt="Diverse creative team brainstorming together around large table with laptops and sketches"
              className="w-full h-full object-cover"
            />
          </div> */}
        </div>
      </div>

      {/* Quality Standards */}
      <div className="bg-white text-black rounded-2xl ">
        <div className="text-center mb-4 space-y-4">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-headline font-black text-foreground">
        
          Our <span className="text-red-600">Quality</span> Standards
        </h2>

        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8">
          {qualityStandards.map((standard, index) => (
            <div key={index} className="text-center border rounded-2xl shadow-subtle p-4 space-y-2">
              <div className="w-10 h-10 shadow-subtle rounded-full flex items-center justify-center mx-auto">
                <Icon name={standard.icon} size={24} color="#eb0000" strokeWidth={2} />
              </div>
              <h4 className="font-bold text-lg">{standard.title}</h4>
              <p className="text-black/80 text-sm">{standard.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Process Philosophy */}
      <div className="text-center max-w-7xl shadow-subtle mx-auto bg-white rounded-2xl p-4 ">
        <Icon name="QuoteIcon" size={48} color="#eb0000" className="mx-auto mb-4" strokeWidth={1.5} />
        <h3 className="text-xl sm:text-3xl font-bold text-primary mb-2">Process Philosophy</h3>
        <p className="text-base sm:text-lg text-muted-foreground">
            "Every frame, every design, every click—we treat it as an opportunity to elevate your brand. HYPE blends Visual Production, Branding, Website & Digital Presence, Social Media, and Advertising into seamless experiences that resonate, captivate, and drive results. Attention to detail is our standard, not an afterthought."
        </p>
      </div>
    </div>
  );
};

export default CreativeProcess;
